(function ($) {
	$(document).ready(function ($) {

		/**
		 * Tabs for the moving system/ accessory Pages
		 */

		if ($('#product-tabs').length > 0) {
			$('.tabs-title').first().click()
		}

		//timeline adjustment

		$('.timeline-post').each(function () {
			var $title = $(this).find('.content-title');
			$(this).find('.content-title').remove();
			$(this).find('.event-description .full-width').append($title);
		});

		$('#motor-slider').slick({
			arrows: true,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			adaptiveHeight: true,
			prevArrow: '<span class="ms-slider__small">' +
				'<span class="ms-slider__circle-border">' +
				'<span class="ms-slider__arrow fas fa-chevron-left"></span>' +
				'</span>' +
				'</span>',
			nextArrow: '<span class="ms-slider__small">' +
				'<span class="ms-slider__circle-border">' +
				'<span class="ms-slider__arrow fas fa-chevron-right"></span>' +
				'</span>' +
				'</span>',
		});

		$('#testimonial-slider').slick({
			arrows: true,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			adaptiveHeight: true,
			prevArrow: '<span class="far fa-chevron-left"></span>',
			nextArrow: '<span class="far fa-chevron-right"></span>'
		});

		$('#ms-slider-one').slick({
			arrows: true,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			adaptiveHeight: true,
			prevArrow: '<span class="ms-slider__small">' +
				'<span class="ms-slider__circle-border">' +
				'<span class="ms-slider__arrow fas fa-chevron-left"></span>' +
				'</span>' +
				'</span>',
			nextArrow: '<span class="ms-slider__small">' +
				'<span class="ms-slider__circle-border">' +
				'<span class="ms-slider__arrow fas fa-chevron-right"></span>' +
				'</span>' +
				'</span>',
		});

		$('#related-slider').slick({
			arrows: true,
			infinite: true,
			speed: 300,
			slidesToShow: 4,
			adaptiveHeight: true,
			prevArrow: '<span class="ms-slider__small">' +
				'<span class="ms-slider__circle-border">' +
				'<span class="ms-slider__arrow fas fa-chevron-left"></span>' +
				'</span>' +
				'</span>',
			nextArrow: '<span class="ms-slider__small">' +
				'<span class="ms-slider__circle-border">' +
				'<span class="ms-slider__arrow fas fa-chevron-right"></span>' +
				'</span>' +
				'</span>',
			responsive: [
				{
					breakpoint: 769,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});

		$('#news-slider').slick({
			arrows: true,
			infinite: true,
			speed: 300,
			slidesToShow: 3,
			adaptiveHeight: false,
			prevArrow: '<span class="ms-slider__small">' +
				'<span class="ms-slider__circle-border">' +
				'<span class="ms-slider__arrow fas fa-chevron-left"></span>' +
				'</span>' +
				'</span>',
			nextArrow: '<span class="ms-slider__small">' +
				'<span class="ms-slider__circle-border">' +
				'<span class="ms-slider__arrow fas fa-chevron-right"></span>' +
				'</span>' +
				'</span>',
			responsive: [
				{
					breakpoint: 769,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});

		// attempt to match height

		// on('setPosition', function (event, slick) {
		// 	slick.$slides.css('height', slick.$slideTrack.height() + 'px');
		// });

		// footer accordions collapsed on mob, expanded on desktop

		let accordionFired = 0;

		if ($(window).width() > 769) {
			if (!$("#footer-accordion-1-item").parent(".is-active").length) {
				$("#footer-accordion-1").foundation('down', $("#footer-accordion-1-item"));
			}
			if (!$("#footer-accordion-2-item").parent(".is-active").length) {
				$("#footer-accordion-2").foundation('down', $("#footer-accordion-2-item"));
			}
		}

		else {
			accordionFired = 1;
		}

		$(window).on('resize', function () {
			if (accordionFired) {
				if ($(window).width() > 960) {
					if (!$("#footer-accordion-1-item").parent(".is-active").length) {
						$("#footer-accordion-1").foundation('down', $("#footer-accordion-1-item"));
					}
					if (!$("#footer-accordion-2-item").parent(".is-active").length) {
						$("#footer-accordion-2").foundation('down', $("#footer-accordion-2-item"));
					}
				}
			}

		});

	});


})(jQuery);

// for the product image gallery
function myFunction(imgs) {
	var expandImg = document.getElementById("expandedImg");
	expandImg.src = imgs.src;

}
